<template lang="html">
  <div v-if="benefitDetailData" class="benefits">
    <NavBar :title="benefitDetailData.venueTitle" back="back" commune="commune" />
    <Banner />
    <h2>{{ benefitDetailData.venueTitle }}</h2>
    <BenefitIframe v-if="benefitDetailData.iframeUrl" />
    <div v-else>
      <img class="hero" :src="getBenefitImageUrl(benefitDetailData)" />
      <div class="content">
        <div class="benefit-overview">
          <div class="benefit-option-list">
            <div class="benefit-option-favorite iconbutton" v-if="loggedInUser" @click="toggleFavorite(benefitId)">
              <font-awesome-icon icon="bookmark"></font-awesome-icon>
              <font-awesome-icon class="benefit-option-favorited" v-if="isFavorited" icon="star"></font-awesome-icon>
            </div>
          </div>
          <div class="benefit-title">{{ benefitDetailData.venueTitle }}</div>
          <div class="benefit-offer" v-html="getSafeBenefitText(benefitDetailData.benefitOffer)"></div>          
          <div class="benefit-description" v-html="getSafeBenefitText(benefitDetailData.benefitDescription)"></div>
          <ShowMoreText class="benefit-optional-description" :initial-is-open=false><div  v-html="getSafeBenefitText(benefitDetailData.benefitOptionalDescription)"></div></ShowMoreText>
          
          <!-- <div class="benefit-map">MAP BUTTON</div> -->
          <a class="benefit-url" target="_blank" :href="getGoogleUrl(benefitDetailData)"><NewTranslation class="benefit-headline" path="benefitsDetail.seeInGoogle"></NewTranslation></a>
        </div>
        <div class="benefit-local" v-if="benefitDetailData.venueDescription">
          <NewTranslation class="benefit-headline" path="benefitsDetail.venueDescription"></NewTranslation>
          <div class="benefit-information">{{ benefitDetailData.venueDescription }}</div>
        </div>
        <div class="contact-list">
          <div class="contact-entry" v-if="benefitDetailData.venueLocation.length > 1">
            <div class="iconbutton icon-pin">
              <font-awesome-icon icon="map-pin"></font-awesome-icon>
            </div>
            <div class="contact-entry-text">{{ benefitDetailData.venueLocation }}</div>
          </div>
          <div class="contact-entry" v-if="benefitDetailData.venueWeb">
            <div class="iconbutton icon-globe">
              <font-awesome-icon icon="globe-americas"></font-awesome-icon>
            </div>
            <div class="contact-entry-text">{{ benefitDetailData.venueWeb }}</div>
          </div>
          <div class="contact-entry" v-if="benefitDetailData.venuePhone">
            <div class="iconbutton">
              <font-awesome-icon icon="phone-alt"></font-awesome-icon>
            </div>
            <div class="contact-entry-text">{{ benefitDetailData.venuePhone }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="qualified && publicTransportBenefit">
      <Button
        color="green"
        center
        @click.native="openPublicTransportTicket()"
        path="benefitsDetail.coupon.publicTransportTicket.showTicket"
      >
        <font-awesome-icon icon="bus" slot="icon" />
      </Button>
    </div>
    <div v-else-if="qualified && publicRestroomBenefit">
      <Button
        color="green"
        center
        @click.native="openPublicRestroomTicket()"
        path="benefitsDetail.coupon.publicRestroomTicket.showTicket"
      >
        <font-awesome-icon icon="ticket-alt" slot="icon" />
      </Button>
    </div>
    <div class="coupon" v-else-if="benefitDetailData.benefitVoidingType!=2" v-bind:class="getClassCoupon()">
      <span
        class="icon icon-info"
        @click="
          showInfo(translate('benefitsDetail.coupon.dialog.body'), translate('benefitsDetail.coupon.dialog.title'))
        "
        ><font-awesome-icon icon="info-circle"></font-awesome-icon
      ></span>
      <NewTranslation
        :path="`benefitsDetail.coupon.voidable.type${benefitDetailData.benefitVoidingType}`"
        @click="openCoupon(benefitDetailData, currentLocation)"
      />
    </div>
    <TabBar />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import i18next from 'i18next';

import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Banner from '@/components/Banner.vue';
import Button from '@/components/Button.vue';
import ShowMoreText from '@/components/ShowMoreText.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import BenefitIframe from '@/components/BenefitIframe.vue';
import RemoteAssets from '@/app/utils/RemoteAssets';

export default {
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Banner,
    BenefitIframe,
    Button,
    ShowMoreText
  },
  data() {
    return {
      benefitId: parseInt(this.$route.query.benefitId, 10),
      qualified: false,
    };
  },
  mounted() {
    if (!this.favorites || this.favorites.length === 0) {
      this.$store.dispatch('loadFavorites');
    }
  },
  created() {
    this.userQualifiedBenefits().then(result => {
      this.qualified = result.qualified;
    });
  },
  methods: {
    translate(path, params) {
      return i18next.t(path, params);
    },
    openCoupon(benefit, currentLocation) {
      //const couponDisabled = this.benefitDetailData.benefitVoided || !this.qualified;
      //console.log(`benefitVoidingsCount: ${this.benefitDetailData.benefitVoidingsCount} maxAmountOfVoidings: ${this.benefitDetailData.maxAmountOfVoidings}`);
      const couponDisabled = this.benefitDetailData.benefitVoidingsCount >= this.benefitDetailData.maxAmountOfVoidings || !this.qualified;
      if (couponDisabled) return;
      this.$store.commit('openOverlay', {
        overlayName: 'CouponGuide',
        overlayData: {
          benefit: {...benefit},
          communeId: currentLocation.id
        },
      });
    },
    showInfo(message, title) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title,
          message,
        },
      });
    },
    toggleFavorite() {
      const benefit = this.$store.getters.benefitsDetail(this.benefitId);
      if (this.isFavorited) {
        this.$store.dispatch('removeFavorite', benefit);
      } else {
        this.$store.dispatch('addFavorite', benefit);
      }
    },
    getBenefitImageUrl(benefit) {
      if (benefit.venueImage) {
        return RemoteAssets.benefitImageUrl(benefit.venueImage);
      } else if (benefit.externalImg) {
        return benefit.externalImg;
      }
      return '';
    },
    getClassCoupon() {
      // console.log(`benefitVoidingsCount: ${this.benefitDetailData.benefitVoidingsCount} maxAmountOfVoidings: ${this.benefitDetailData.maxAmountOfVoidings}`);
      return {
        'is-valid': this.qualified,
        'is-invalid': !this.qualified || this.benefitDetailData.benefitVoidingsCount >= this.benefitDetailData.maxAmountOfVoidings,
      };
    },
    getGoogleUrl(benefit) {
      const benefitLat = benefit.benefitLat;
      const benefitLng = benefit.benefitLng;
      if (!!benefit.venueGoogleId) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(benefit.venueTitle)}&query_place_id=${benefit.venueGoogleId}`;
      }
		  return `https://www.google.com/maps/search/?api=1&query=${benefitLat}%2C${benefitLng}`;
		  //return `https://www.google.com/maps/search/?api=1&query=${benefitLat}%2C${benefitLng}+${encodeURIComponent(benefit.venueTitle)}`//With name
    },
    async openPublicTransportTicket() {
      this.$store.commit('openOverlay', {
        overlayName: 'PublicTransportTicket',
      });
    },
    async openPublicRestroomTicket() {
      this.$store.commit('openOverlay', {
        overlayName: 'PublicRestroomTicket',
        overlayData: {
          title: this.benefitDetailData.venueTitle,
          imageSrc: '/img/restroom-qrcode.png',
        },
      });
    },
    getSafeBenefitText(value) {
      if (value) {
        const resultParsed = `<div class="benefit-safe-text-wrapper">${value}</div>`;
        return resultParsed;
      }
      return '';
    },  
    ...mapActions(['userQualifiedBenefits']),
  },
  computed: {
    ...mapGetters(['favorites', 'loggedInUser', 'currentLocation']),
    isFavorited() {
      console.log("Favorites", this.favorites);
      if (!this.favorites || this.favorites.length === 0) {
        return false;
      }
      return this.favorites.some(fav => fav.id === this.$store.getters.benefitsDetail(this.benefitId).id);
    },
    benefitDetailData() {
      const benefitDetailInfo = this.$store.getters.benefitsDetail(this.benefitId);
      console.log("BenefitDetailInfo", benefitDetailInfo);
      return this.$store.getters.benefitsDetail(this.benefitId);
    },
    publicTransportBenefit() {
      // TODO: add boolean field for enabling public transport ticket
      // Hardcoded mapping for now:
      // - legacy commune uses benefitId 200
      // - Sassnitz (communeId 2035) uses benefitId 1318
      if (this.benefitId == 200) return true;
      return this.currentLocation && this.currentLocation.id == 2035 && this.benefitId == 1318;
    },
    publicRestroomBenefit() {
      // TODO: add boolean field for enabling public restroom ticket
      return this.benefitId == 1317;
    },
  },
};
</script>

<style lang="sass" scoped>
.benefits
  padding-bottom: 100px

.hero
  width: 100%
  height: 250px
  object-fit: cover
  object-position: center center

.content
  padding: 20px

.benefit
  &-overview
    position: relative
    padding-bottom: 20px
    border-bottom: 1px solid #F4F4F6

  &-option
    &-list
      position: absolute
      top: 0
      right: 0
      display: flex

    &-share
      padding: 7px

    &-favorite
      padding: 7px 8px
      position: relative

    &-favorited
      color: white
      position: absolute
      top: 8px
      left: 9px
      width: 12px

  &-title
    font-size: 1.25rem
    max-width: calc(100% - 90px)

  &-description
    margin-top: 5px
    max-width: calc(100% - 50px)

  &-optional-description
    margin-top: 5px
    max-width: calc(100% - 50px)

  &-offer
    margin-top: 5px
    max-width: calc(100% - 50px)

  &-map
    margin-top: 5px
    max-width: calc(100% - 50px)
  
  &-url
    display: block
    margin-top: 10px
    max-width: calc(100% - 50px)

  &-rating
    display: flex
    margin: 10px 0 0

    &-google
      margin-right: 4px

    &-star
      height: 20px
      width: 14px
      object-fit: contain
    // margin: 0 3px
    &-full
      color: #D1701D

    &-empty
      color: #454F63

    &-amount
      font-size: 0.8rem
      color: #444
      margin-left: 5px

  &-local
    padding-bottom: 20px
    border-bottom: 1px solid #F4F4F6
    padding-top: 20px

  &-headline
    font-size: 1.25rem

  &-information
    margin-top: 6px

.contact
  &-list
    padding-top: 20px

  &-entry
    display: flex
    align-items: center
    margin: 10px 0

.openinghour
  display: flex
  flex-direction: column
  align-items: flex-end

  &-entry
    display: flex
    justify-content: space-between
    max-width: calc(100% - 42px)
    width: 100%
    margin-bottom: 3px
    font-size: .8rem

    &.is-today
      font-weight: bold

  // &-day

  // &-time

.icon-pin
  padding: 6px 8px

.icon-globe
  padding: 6px 8px

.icon
  width: 20px
  height: 20px
  display: inline-flex
  justify-content: center
  align-items: center
  border-radius: 20px
  border: 1px solid #1DB2D1

  svg
    color: #1DB2D1

  &-toggle
    margin-left: auto

    &.is-active
      transform: rotate(180deg)

    svg
      width: 10px

.coupon
  display: flex
  justify-content: center
  align-items: center
  height: 60px
  color: #fff
  text-decoration: underline
.is-valid
  background-color: #27D190
.is-invalid
  background-color: #DE3D36

.icon
  width: 20px
  height: 20px
  display: inline-flex
  justify-content: center
  align-items: center
  border-radius: 20px
  border: 1px solid #fff

  svg
    color: #fff

  &-info
    margin-right: 15px
    border: none

  &-toggle
    margin-left: auto

    svg
      width: 10px
</style>
